module.exports = __webpack_public_path__ + "2bf246bb3afdb65cee789f87828ca141.svg";